import { render, staticRenderFns } from "./PbColumn.vue?vue&type=template&id=7e2fb567&"
import script from "./PbColumn.vue?vue&type=script&lang=js&"
export * from "./PbColumn.vue?vue&type=script&lang=js&"
import style0 from "./PbColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports